module.exports = __webpack_public_path__ + "media/images/nomap_status-3fc842c3d3a0e2a8e671f963b2bbc1c9.svg";